// @flow
import {
    EVENT_CREATE_ERROR,
    EVENT_CREATE_LOADING,
    EVENT_CREATE_SUCCESS,
} from "../actions/constants";
import type { Actions } from "../actions/actions";

type State = {
    created?: ?Object,
    loading: boolean,
    error: string | boolean | null,
};

const initialState = {
    created: null,
    loading: false,
    error: null,
};

function reducer(state: State = initialState, action: Actions) {
    if (action.type === EVENT_CREATE_ERROR) {
        return { ...state, error: action.payload };
    }

    if (action.type === EVENT_CREATE_LOADING) {
        return { ...state, loading: action.payload };
    }

    if (action.type === EVENT_CREATE_SUCCESS) {
        return { ...state, created: action.payload };
    }

    return state;
}

export default reducer;
